module.exports = __webpack_public_path__ + "assets/img/kv-d79f8e09.jpg";